import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';

import { ServiceError, useError } from 'Src/network/useError';

import service, { DayPartScheduleGetAllResponse, serviceKey } from './dayPartScheduleService';

const queryKeys = {
  getAll: () => [serviceKey.getAll],
};

const useDayPartScheduleQuery = <T = DayPartScheduleGetAllResponse>(select?: (data?: DayPartScheduleGetAllResponse | undefined) => T) => {
  const { t } = useTranslation();
  const { parseError } = useError({ activity: t('dayparts.errors.getAll') });
  return useQuery<DayPartScheduleGetAllResponse, ServiceError, T>({
    gcTime: Infinity,
    staleTime: Infinity,
    queryKey: queryKeys.getAll(),
    queryFn: async () => {
      try {
        return await service.getAll();
      } catch (e) {
        throw parseError(e);
      }
    },
    select,
  });
};

const useDayPartSchedule = {
  query: {
    getAll: useDayPartScheduleQuery,
  },
  mutate: {
    // TODO: include messaging for DayPartSchedule to mutate based on messages from socket
  },
};

export { useDayPartSchedule };

